export function getUserRate({ value, total }: any) {
  const rate: any = Number((value / total) * 100).toFixed(1);
  return isNaN(rate) ? 0 : rate;
}

export function getGrowthTrends(data: any) {
  const {
    growthToday = 0,
    growthThisWeek = 0,
    growthThisMonth = 0,
    growthThisYear = 0,
  } = data || {};
  return {
    day: growthToday,
    week: growthThisWeek,
    month: growthThisMonth,
    year: growthThisYear,
  };
}

export function calculateContainerProperties({ top, width, screens }: any) {
  const windowHeight = window.innerHeight;
  const gap = width / 100;

  let col = (width - gap) / 2;
  let height = col * 2;
  let factor = 25;

  if (screens.lg) {
    col = (width - 3 * gap) / 4;
    height = windowHeight > 700 ? col : col / 1.1;
  }

  if (screens.xl) {
    col = (width - 3 * gap) / 4;
    height = col;
    factor = 10;
  }

  if (screens.xxl) {
    height = col / 1.1;
    factor = 15;
  }

  return { maxHeight: windowHeight - top - factor, gap, height };
}
